export default __webpack_public_path__ + "static/media/Human Resource Planning.97a2792c.png";